import UpdateExpiryDate from 'features/myVaro/screens/ExternalAccounts/UpdateExpiryDate/UpdateExpiryDate';
import React from 'react';

export default function UpdateExpiryDatePage() {
  return <UpdateExpiryDate />;
}
